import { useEffect, useState } from 'react';
import { isTablet, isMobileOnly, isMobile } from 'react-device-detect';

function useDetectTablet() {
  const [tablet, setIsTablet] = useState(false);
  useEffect(() => setIsTablet(isTablet), [setIsTablet]);
  return tablet;
}

function useDetectMobile() {
  const [mobile, setMobile] = useState(false);
  useEffect(() => setMobile(isMobileOnly), [setMobile]);
  return mobile;
}

function useDetectMobileAndTablet() {
  const [mobileAndTablet, setMobileAndTablet] = useState(false);
  useEffect(() => setMobileAndTablet(isMobile), [setMobileAndTablet]);
  return mobileAndTablet;
}

export { useDetectTablet, useDetectMobile, useDetectMobileAndTablet };
